import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetDriversResponseModel } from '../models/get-driver-response.model';
import { HttpClient } from '@angular/common/http';
import { TableEventModel } from '../../../shared/models/table-events.model';
import { FilterModel } from '../../../shared/models/filter.model';
import { UserPayload } from '../models/user-payload.model';
import { parseParamsFromObject } from '../../../shared/utils/params-from-objects.map';
import { DriverById } from '../models/driver-by-id.model';
import { DefaultDataWrapper } from '../../../shared/models/default-data-wrapper.model';
import { TotalCount } from '../models/total-count.model';
import { BlockMultiplePayload } from '../models/block-multiple-payload.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DriversApiService {
  private http = inject(HttpClient);

  searchDrivers(filter: FilterModel, tableEvent: TableEventModel) {
    const params = parseParamsFromObject({
      ...filter,
      ...tableEvent,
    });
    return this.http.get<GetDriversResponseModel>(
      '/corporate-client/driver/search',
      { params }
    );
  }

  attachDrivers(data: { driver_id: number; vehicle_ids: number[] }) {
    return this.http.put('/corporate-client/driver/attach-vehicles', data);
  }

  getDriverById(id: number | null) {
    return this.http.get<DefaultDataWrapper<DriverById>>(
      `/corporate-client/driver/view/${id}`
    );
  }

  getTotalCount() {
    return this.http.get<DefaultDataWrapper<TotalCount>>(
      '/corporate-client/driver/total-count'
    );
  }

  getTotalAccount() {
    return this.http.get(`${environment.baseUrl}/master-account`);
  }

  getTotalCountMa(id: any) {
    return this.http.get<DefaultDataWrapper<TotalCount>>(
      `${environment.baseUrl}/master-account/corporate-client/${id}/drivers/total-count`
    );
  }

  addDriver(driver: UserPayload): Observable<any> {
    return this.http.post('/corporate-client/driver/add-handler', driver);
  }

  editUser(id: string, user: UserPayload): Observable<any> {
    return this.http.post(`/corporate-client/driver/edit-handler/${id}`, user);
  }

  deleteUser(id: string): Observable<any> {
    return this.http.delete(`/corporate-client/driver/delete-handler/${id}`);
  }

  blockUnblock(id: number): Observable<any> {
    return this.http.get(`/corporate-client/driver/block-unblock/${id}`);
  }

  blockMultiple(payload: Array<number>): Observable<any> {
    const processedPayload: BlockMultiplePayload = {
      drivers: payload.map((value) => {
        return {
          id: value,
        };
      }),
    };
    return this.http.post(
      '/corporate-client/driver/block-drivers',
      processedPayload
    );
  }

  unblockMultiple(payload: Array<number>): Observable<any> {
    const processedPayload: BlockMultiplePayload = {
      drivers: payload.map((value) => {
        return {
          id: value,
        };
      }),
    };
    return this.http.post(
      '/corporate-client/driver/unblock-drivers',
      processedPayload
    );
  }
}
